import script from "./addTrackedPotentialForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./addTrackedPotentialForm.vue?vue&type=script&setup=true&lang=ts"

import "./addTrackedPotentialForm.vue?vue&type=style&index=0&id=40363a9c&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40363a9c"]])

export default __exports__